  import Vue                               from "vue";
  import App                               from "./App.vue";
  import "./registerServiceWorker";
  import router                            from "./router";
  import store                             from "./store";
  import Meta                              from "vue-meta";
  import {BootstrapVue, BootstrapVueIcons} from "bootstrap-vue";
  import "bootstrap/dist/css/bootstrap.css";
  import "bootstrap-vue/dist/bootstrap-vue.css";
  import AppLayout                         from "./layouts/AppLayout.vue";
  import AuthLayout                        from "./layouts/AuthLayout.vue";
  import i18n                              from "./plugins/i18n";
  import Multiselect                       from "vue-multiselect";
  import VueCodemirror                     from "vue-codemirror";
  import IconsPlugin                       from "bootstrap-vue";
  import "@/plugins/custom-veevalidate";
  import {localize}                        from "vee-validate";
  import Sortable                          from 'vue-sortable';
  import Antd, {Menu}                      from "ant-design-vue";
  import "ant-design-vue/dist/antd.css";
  import CKEditor from "@ckeditor/ckeditor5-vue2";

  Vue.use(CKEditor);
  Vue.use(BootstrapVue);
  Vue.use(IconsPlugin);
  Vue.use(BootstrapVue);
  Vue.use(BootstrapVueIcons);
  Vue.use(Sortable);
  Vue.use(Meta);
  Vue.use(Antd);
  Vue.use(Menu);
  Vue.component("AppLayout", AppLayout);
  Vue.component("AuthLayout", AuthLayout);
  Vue.component("multiselect", Multiselect);
  Vue.config.productionTip = false;
  Vue.use(VueCodemirror);
  import "vue-multiselect/dist/vue-multiselect.min.css";
  import "codemirror/lib/codemirror.css";

  Vue.config.productionTip = false;

  new Vue({
      router,
      store,
      i18n,
    render: h => h(App),
    created() {
      this.loadLocale("vi");
      // Check domain và đổi favicon
        const hostname = window.location.hostname;
        if (hostname === 'test.sangsang.com.vn') {
            //const link = document.querySelector("link[rel~='icon']");
            // Chọn icon 32x32
            const icon32 = document.querySelector("link[rel~='icon'][sizes='32x32']");

            // Chọn icon 16x16
            const icon16 = document.querySelector("link[rel~='icon'][sizes='16x16']");
            if (icon16) {
            icon16.href = '/img/icons/favicon-sangsang-16.png';
            } 
            if (icon32) {
            icon32.href = '/img/icons/favicon-sangsang-32.png';
            } 
        }
    },
    methods: {
      toast(title, variant = null, content = null, append = false) {
        this.$bvToast.toast(`${content}`, {
          title: `${title}`,
          toaster: "b-toaster-top-center",
          autoHideDelay: 4000,
          solid: true,
          variant: variant,
          appendToast: append
        });
      },
      confirm(
        message = this.$t("commons.message.default_confirm"),
        okVariant = "danger",
        okeTitle = this.$t("commons.button.ok"),
        cancelTitle = this.$t("commons.button.cancel")
      ) {
        return this.$bvModal
          .msgBoxConfirm(message, {
            id: "popupConfirm",
            size: "sm",
            buttonSize: "sm",
            okVariant: okVariant,
            okTitle: okeTitle,
            okClass: "confirm",
            cancelTitle: cancelTitle,
            footerClass: "row-button-popup",
            hideHeaderClose: false,
            centered: true
          })
          .then(value => value)
          .catch(err => err);
      },
      loadLocale(code) {
        return import(`vee-validate/dist/locale/${code}.json`).then(locale => {
          localize(code, locale);
        });
      }
    }
  }).$mount("#app");
